import "./Departments.scss";
import { useState } from "react";
import { useMediaQuery } from "@mui/material";
import GreenButton from "../../components/GreenButton/GreenButton";
import FactoriesView from "./FactoriesView/FactoriesView";
import ProductsView from "./ProductsView/ProductsView";
import ShopsView from "./ShopsView/ShopsView";

const Departments = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const [currentView, setCurrentView] = useState("factories");

  const renderView = () => {
    switch (currentView) {
      case "factories":
        return <FactoriesView />;
      case "shops":
        return <ShopsView />;
      case "products":
        return <ProductsView />;
      default:
        return null;
    }
  };

  return (
    <div className="departments">
      <div className="departments-header">
        <p className="title">الاقسام</p>

        <div className="btns-container">
          <GreenButton
            text="اقسام المصانع"
            size={isMobile ? "full" : "medium"}
            variant={currentView === "factories" ? "fill" : "outlined"}
            onClick={() => setCurrentView("factories")}
          />

          <GreenButton
            text="اقسام المتاجر"
            size={isMobile ? "full" : "medium"}
            variant={currentView === "shops" ? "fill" : "outlined"}
            onClick={() => setCurrentView("shops")}
          />

          <GreenButton
            text="سمات المنتجات"
            size={isMobile ? "full" : "medium"}
            variant={currentView === "products" ? "fill" : "outlined"}
            onClick={() => setCurrentView("products")}
          />
        </div>

        {renderView()}
      </div>
    </div>
  );
};

export default Departments;
